import type { FC } from 'react';
import { Button } from '@mui/material';
import type { ButtonOwnProps } from '@mui/material/Button/Button';

import { SECTION } from 'src/constants/section';
import history from 'src/services/routing/history';
import { routePaths } from 'src/services/routing/routePaths';
import useUserPermissions from 'src/components/app/context/UserContext/useUserPermissions';

export const FOLLOWUP_ACTION_BUTTON_TEST_ID = 'followup-action-button';

interface FollowUpActionButtonProps
  extends Pick<ButtonOwnProps, 'color' | 'variant'> {}

export const FollowUpActionButton: FC<FollowUpActionButtonProps> = ({
  color,
  variant = 'cta',
}) => {
  const { hasPermissionForModuleType } = useUserPermissions();
  if (!hasPermissionForModuleType(SECTION.FOLLOW_UP_ACTION)) return null;

  const href = history.createHref({
    pathname: routePaths.FOLLOW_UP_ACTIONS,
  });

  return (
    <Button
      data-test-id={FOLLOWUP_ACTION_BUTTON_TEST_ID}
      variant={variant}
      color={color}
      onClick={() => window.open(href, '_blank')}
    >
      Follow-Up Actions
    </Button>
  );
};
